import {
  CameraFilled,
  CheckOutlined,
  FolderOpenOutlined,
  LineOutlined,
  LoadingOutlined,
} from "@ant-design/icons";
import { Col, Row, Image, Button } from "antd";

import visionBase from "../images/vision_base.png";
import TestUI from "./TestUI";
import { PosturalExamination, PosturalTestDefinition } from "./interfaces";
import { photoNotTakenYet, TakenPhoto } from "./PosturalExamWrapper";
import { useEffect, useRef, useState } from "react";

const PosturalExamVision_TakePhoto = ({
  images,
  getWebcamPhoto,
  loadPhoto,
}: {
  images: TakenPhoto[];
  getWebcamPhoto: Function;
  loadPhoto: Function;
}) => {
  const ref1 = useRef<any>();

  //For Responsive

  const [width, setWidth] = useState(0);
  const handleResize = () => setWidth(window.innerWidth);

  useEffect(() => {
    //mount
    window.addEventListener("resize", handleResize);
    setWidth(window.innerWidth);
    //unmount
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <>
      {width > 640 && (
        <div className="centered" style={{ width: "64%" }}>
          <Row>
            <Col span={1} />
            <Col span={22}>
              <div>
                <Image
                  style={{
                    borderRadius: "25px",
                  }}
                  fallback={visionBase}
                  preview={
                    images.length >= 1 && images[0].url != photoNotTakenYet.url
                  }
                  src={(images.length >= 1 && images[0].url) || visionBase}
                />
              </div>
              <Button
                style={{
                  color: "white",
                }}
                onClick={() => getWebcamPhoto(0)}
              >
                <CameraFilled rev={undefined} />
              </Button>
              <Button
                style={{
                  color: "white",
                }}
                onClick={() => ref1.current?.click()}
              >
                {" "}
                <input
                  type={"file"}
                  accept={"image/*"}
                  style={{ display: "none" }}
                  ref={ref1}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                    if (e && e.target && e.target.files)
                      loadPhoto(0, e.target.files[0]);
                  }}
                />
                <FolderOpenOutlined rev={undefined} />
              </Button>
              <Button
                disabled={true}
                style={{
                  background:
                    images.length >= 1 && images[0].url != photoNotTakenYet.url
                      ? images[0].uploaded
                        ? "#9edcc4"
                        : "#598f7a"
                      : "#a785a9",
                  color: "white",
                  cursor: "default",
                }}
              >
                {images.length >= 1 && images[0].url != photoNotTakenYet.url ? (
                  images[0].uploaded ? (
                    <CheckOutlined rev={undefined} />
                  ) : (
                    <LoadingOutlined rev={undefined} />
                  )
                ) : (
                  <LineOutlined rev={undefined} />
                )}
              </Button>
            </Col>
            <Col span={1} />
          </Row>
        </div>
      )}
      {width <= 640 && (
        <div className="centrados" style={{ width: "64%" }}>
          <Row>
            <Col span={1} />
            <Col span={22}>
              <div style={{ zoom: "0.5" }}>
                <Image
                  style={{
                    zoom: "0.3",
                    borderRadius: "200px",
                  }}
                  fallback={visionBase}
                  preview={
                    images.length >= 1 && images[0].url != photoNotTakenYet.url
                  }
                  src={(images.length >= 1 && images[0].url) || visionBase}
                />
              </div>

              <Button
                style={{
                  color: "white",
                }}
                onClick={() => ref1.current?.click()}
              >
                {" "}
                <input
                  type={"file"}
                  accept={"image/*"}
                  style={{ display: "none" }}
                  ref={ref1}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                    if (e && e.target && e.target.files)
                      loadPhoto(0, e.target.files[0]);
                  }}
                />
                <CameraFilled rev={undefined} />
              </Button>
              <Button
                disabled={true}
                style={{
                  background:
                    images.length >= 1 && images[0].url != photoNotTakenYet.url
                      ? images[0].uploaded
                        ? "#9edcc4"
                        : "#598f7a"
                      : "#a785a9",
                  color: "white",
                  cursor: "default",
                }}
              >
                {images.length >= 1 && images[0].url != photoNotTakenYet.url ? (
                  images[0].uploaded ? (
                    <CheckOutlined rev={undefined} />
                  ) : (
                    <LoadingOutlined rev={undefined} />
                  )
                ) : (
                  <LineOutlined rev={undefined} />
                )}
              </Button>
            </Col>
            <Col span={1} />
          </Row>
        </div>
      )}
    </>
  );
};

const PosturalExamVisionRight = ({
  page,
  images,
  getWebcamPhoto,
  loadPhoto,
  testDefinitions,
  posturalExamination,
  setTestSelection,
}: {
  page: number;
  images: TakenPhoto[];
  getWebcamPhoto: Function;
  loadPhoto: Function;
  testDefinitions: PosturalTestDefinition[];
  posturalExamination: PosturalExamination;
  setTestSelection: Function;
}) => {
  if (testDefinitions && testDefinitions.length > 0)
    testDefinitions.sort((td1, td2) => td1.id - td2.id);
  return (
    <>
      {page == 0 && (
        <PosturalExamVision_TakePhoto
          images={images}
          loadPhoto={loadPhoto}
          getWebcamPhoto={getWebcamPhoto}
        />
      )}
      {page == 1 && (
        <>
          <TestUI
            testDefinition={
              testDefinitions.length > 2 ? testDefinitions[2] : undefined
            }
            testSelection={
              posturalExamination.testSelections &&
              posturalExamination.testSelections.length > 2
                ? posturalExamination.testSelections[2]
                : undefined
            }
            setTestSelection={setTestSelection}
          />
          {page == 1 &&
            posturalExamination.testSelections &&
            posturalExamination.testSelections[2].selectedValue == 0 && ( // LEO CONTROLLA VALORE DEL TEST PORTA/NON PORTA OCCHIALI
              <TestUI
                testDefinition={
                  testDefinitions.length > 3 ? testDefinitions[3] : undefined
                }
                testSelection={
                  posturalExamination.testSelections &&
                  posturalExamination.testSelections.length > 3
                    ? posturalExamination.testSelections[3]
                    : undefined
                }
                setTestSelection={setTestSelection}
              />
            )}
        </>
      )}
      {page == 1 &&
        posturalExamination.testSelections &&
        posturalExamination.testSelections[2].selectedValue == 0 && (
          <>
            <TestUI
              testDefinition={
                testDefinitions.length > 4 ? testDefinitions[4] : undefined
              }
              testSelection={
                posturalExamination.testSelections &&
                posturalExamination.testSelections.length > 4
                  ? posturalExamination.testSelections[4]
                  : undefined
              }
              setTestSelection={setTestSelection}
            />
            <TestUI
              testDefinition={
                testDefinitions.length > 5 ? testDefinitions[5] : undefined
              }
              testSelection={
                posturalExamination.testSelections &&
                posturalExamination.testSelections.length > 5
                  ? posturalExamination.testSelections[5]
                  : undefined
              }
              setTestSelection={setTestSelection}
            />
          </>
        )}
      {page == 2 && (
        <>
        <TestUI
            testDefinition={
              testDefinitions.length > 12 ? testDefinitions[12] : undefined
            }
            testSelection={
              posturalExamination.testSelections &&
              posturalExamination.testSelections.length > 12
                ? posturalExamination.testSelections[12]
                : undefined
            }
            setTestSelection={setTestSelection}
          />
         
          <TestUI
            testDefinition={
              testDefinitions.length > 1 ? testDefinitions[1] : undefined
            }
            testSelection={
              posturalExamination.testSelections &&
              posturalExamination.testSelections.length > 1
                ? posturalExamination.testSelections[1]
                : undefined
            }
            setTestSelection={setTestSelection}
          />
        </>
      )}
      {page == 3 && (
        <>
          <TestUI
            testDefinition={
              testDefinitions.length > 0 ? testDefinitions[0] : undefined
            }
            testSelection={
              posturalExamination.testSelections &&
              posturalExamination.testSelections.length > 0
                ? posturalExamination.testSelections[0]
                : undefined
            }
            setTestSelection={setTestSelection}
          />
          <TestUI
            testDefinition={
              testDefinitions.length > 7 ? testDefinitions[7] : undefined
            }
            testSelection={
              posturalExamination.testSelections &&
              posturalExamination.testSelections.length > 7
                ? posturalExamination.testSelections[7]
                : undefined
            }
            setTestSelection={setTestSelection}
          />
        </>
      )}
      {page == 4 && (
        <>
          <TestUI
            testDefinition={
              testDefinitions.length > 8 ? testDefinitions[8] : undefined
            }
            testSelection={
              posturalExamination.testSelections &&
              posturalExamination.testSelections.length > 8
                ? posturalExamination.testSelections[8]
                : undefined
            }
            setTestSelection={setTestSelection}
          />
          <TestUI
            testDefinition={
              testDefinitions.length > 9 ? testDefinitions[9] : undefined
            }
            testSelection={
              posturalExamination.testSelections &&
              posturalExamination.testSelections.length > 9
                ? posturalExamination.testSelections[9]
                : undefined
            }
            setTestSelection={setTestSelection}
          />
        </>
      )}

      {page == 5 && ( //TODO LEO Change test number with right selection
        <>
          <TestUI
            testDefinition={
              testDefinitions.length > 11 ? testDefinitions[11] : undefined
            }
            testSelection={
              posturalExamination.testSelections &&
              posturalExamination.testSelections.length > 11
                ? posturalExamination.testSelections[11]
                : undefined
            }
            setTestSelection={setTestSelection}
          />
           <TestUI
            testDefinition={
              testDefinitions.length > 6 ? testDefinitions[6] : undefined
            }
            testSelection={
              posturalExamination.testSelections &&
              posturalExamination.testSelections.length > 6
                ? posturalExamination.testSelections[6]
                : undefined
            }
            setTestSelection={setTestSelection}
          />
          
        </>
      )}
      {page == 6 && (
        <>
          <TestUI
            testDefinition={
              testDefinitions.length > 13 ? testDefinitions[13] : undefined
            }
            testSelection={
              posturalExamination.testSelections &&
              posturalExamination.testSelections.length > 13
                ? posturalExamination.testSelections[13]
                : undefined
            }
            setTestSelection={setTestSelection}
          />
        </>
      )}

      {page == 7 && (
        <>
          <TestUI
            testDefinition={
              testDefinitions.length > 14 ? testDefinitions[14] : undefined
            }
            testSelection={
              posturalExamination.testSelections &&
              posturalExamination.testSelections.length > 14
                ? posturalExamination.testSelections[14]
                : undefined
            }
            setTestSelection={setTestSelection}
          />
        </>
      )}
    </>
  );
};

export default PosturalExamVisionRight;
